import { HttpBackend } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { CfgService } from '../../cfg/cfg.service';
import { ServerAddressesCfgService } from 'src/app/util/serverAddressesCfg.service';

export class RecruitmentCenterCfg {
  public bucketRecruitmentEndPointPattern: string;
  public talentFillEndPointPattern: string;
  public talentWorkerEndPointPattern: string;
  public talentHistoryEndPointPattern: string;
}

@Injectable()
export class DashboardRecruitmentCfgService extends CfgService<RecruitmentCenterCfg> {
  json: any = {
    bucketRecruitmentEndPointPattern: "%{DashboardApiUrl}/recruitmentcenter/bucket/info?email={0}",
    talentFillEndPointPattern: "%{TalentApiUrl}/#/candidates?branchId={0}&tab=buckets&bucketId={1}&officeBucketId={2}",
    talentWorkerEndPointPattern: "%{TalentApiUrl}/#/candidates?branchId={0}&tab=workProcess",
    talentHistoryEndPointPattern: "%{TalentApiUrl}/#/candidates?branchId={0}&tab=buckets&bucketId={1}&officeBucketId={2}"
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/dashboardRecruitment.cfg.json`;
  }

  /**
   * Carga las url en el json
   */
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
